export const MIN_RISK_METRICS_AXIS_RANGE_SIZE: number = 7;

export const CQS_TICKS_KEYS: number[] = [
  0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100,
];

export const ACR_TICKS_KEYS: string[] = [
  'D',
  'CC/C',
  'CCC3',
  'CCC2',
  'CCC1',
  'B3',
  'B2',
  'B1',
  'BB3',
  'BB2',
  'BB1',
  'BBB3',
  'BBB2',
  'BBB1',
  'A3',
  'A2',
  'A1',
  'AA3',
  'AA2',
  'AA1',
  'AAA',
];
